module.exports = __webpack_public_path__ + "static/media/engaged_learners.e8693c1a.svg";